import { SwiperPagination, useGetSystemDataQuery } from '@monorepo/shared';
import featureIcon1 from '../../images/home/feature/icon-1.png';
import featureIcon2 from '../../images/home/feature/icon-2.png';
import featureIcon3 from '../../images/home/feature/icon-3.png';
import featureIcon4 from '../../images/home/feature/icon-4.png';

import featureIcon5 from '../../images/home/feature/icon-5.png';
import featureIcon6 from '../../images/home/feature/icon-6.png';
import featureIcon7 from '../../images/home/feature/icon-7.png';
import featureIcon8 from '../../images/home/feature/icon-8.png';

import licenseIcon1 from '../../images/home/license/icon-1.png';
import licenseIcon2 from '../../images/home/license/icon-2.png';
import licenseIcon3 from '../../images/home/license/icon-3.png';
import licenseIcon4 from '../../images/home/license/icon-4.png';
import licenseIcon5 from '../../images/home/license/icon-5.png';
import featureEdge from '../../images/home/feature/feature-edge.png';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Mousewheel, Navigation, Autoplay } from 'swiper/modules';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack } from 'rsuite';
import { DateTime } from 'luxon';
import { server } from '../../config/const';
import serviceTermPdf from '/SD-FortiSOC-Cloud.pdf';
interface IProps {
  enableMouse: boolean;
  direction: 'horizontal' | 'vertical' | undefined;
}
export const MainSwiper = ({ enableMouse, direction }: IProps) => {
  const { t } = useTranslation();
  const [swiperInstance, setSwiperInstance] = useState<any>(null);
  const [activeIndex, setActiveIndex] = useState<number>(0);
  useEffect(() => {
    if (swiperInstance) {
      const obj = swiperInstance;
      enableMouse ? obj.mousewheel?.enable() : obj.mousewheel?.disable();
    }
  }, [enableMouse]);
  return (
    <Swiper
      onSwiper={(swiper: any) => {
        setSwiperInstance(swiper);
      }}
      autoplay={{
        // delay: 8000,
        delay: 15000,
        pauseOnMouseEnter: true
      }}
      style={{ height: '100%', width: '100%' }}
      direction={direction}
      slidesPerView={1}
      spaceBetween={0}
      navigation={true}
      mousewheel={true}
      // pagination={{
      //   clickable: true
      // }}
      // modules={[Mousewheel, Pagination, Navigation, Autoplay]}
      modules={[Mousewheel, Navigation, Autoplay]}
      className="land-swiper"
      onSlideChange={(s: any) => {
        setActiveIndex(s.realIndex);
      }}
    >
      <div className="land-swiper-pager"></div>
      <SwiperSlide>
        <Features />
      </SwiperSlide>
      <SwiperSlide>
        <License />
      </SwiperSlide>
      {/* <SwiperSlide>
        <Version />
      </SwiperSlide> */}
      <SwiperPagination total={2} index={activeIndex}></SwiperPagination>
    </Swiper>
  );
};

export const Features = () => {
  const { t } = useTranslation();
  return (
    <div className="land-feature">
      <div className="feature-list">
        <div className="feature-content">
          <span className="title">{t('soc.home.features')}</span>
          <p className="feature-info">{t('soc.home.featuresInfo')}</p>
          <div className="item-list">
            <div className="item-list-container">
              <div className="feature-item">
                <div className="item-icon first">
                  <img src={featureIcon1} />
                </div>
                <div className="item-text">{t('soc.home.feature1')}</div>
              </div>
              <div className="feature-item">
                <div className="item-icon second">
                  <img src={featureIcon2} />
                </div>
                <div className="item-text">{t('soc.home.feature2')}</div>
              </div>
              <div className="feature-item">
                <div className="item-icon third">
                  <img src={featureIcon3} />
                </div>
                <div className="item-text">{t('soc.home.feature3')}</div>
              </div>
              <div className="feature-item">
                <div className="item-icon fourth">
                  <img src={featureIcon4} />
                </div>
                <div className="item-text">{t('soc.home.feature4')}</div>
              </div>
            </div>
            <img className="feature-edge" src={featureEdge} />
          </div>
        </div>
      </div>
      <div className="benefit-list">
        <span className="title">{t('soc.home.benefits')}</span>
        <div className="benefit-item">
          <div className="item-icon first">
            <img src={featureIcon5} />
          </div>
          <div className="item-text">{t('soc.home.benefit1')}</div>
        </div>
        <div className="benefit-item">
          <div className="item-icon second">
            <img src={featureIcon6} />
          </div>
          <div className="item-text">{t('soc.home.benefit2')}</div>
        </div>
        <div className="benefit-item">
          <div className="item-icon third">
            <img src={featureIcon7} />
          </div>
          <div className="item-text">{t('soc.home.benefit3')}</div>
        </div>
        <div className="benefit-item">
          <div className="item-icon fourth">
            <img src={featureIcon8} />
          </div>
          <div className="item-text">{t('soc.home.benefit4')}</div>
        </div>
      </div>
    </div>
  );
};
export const License = () => {
  const { t } = useTranslation();
  const currentYear = DateTime.fromJSDate(new Date()).year;
  const { data: systemData } = useGetSystemDataQuery({
    server: server
  });

  return (
    <div className="land-license">
      <div className="title">{t('soc.home.license')}</div>
      <div className="license-content">
        <div className="license-center">
          <div className="center-item">
            <div className="item-icon">
              <img src={licenseIcon1} />
            </div>
            <div className="item-text">{t('soc.home.licenseCenter1')}</div>
          </div>
          <div className="center-item">
            <div className="item-icon second">
              <img src={licenseIcon2} />
            </div>
            <div className="item-text">{t('soc.home.licenseCenter2')}</div>
          </div>
          <div className="center-item">
            <div className="item-icon third">
              <img src={licenseIcon3} />
            </div>
            <div className="item-text">{t('soc.home.licenseCenter3')}</div>
          </div>
        </div>
        <div className="license-manage">
          <div className="manage-item">
            <div className="item-icon">
              <img src={licenseIcon4} />
            </div>
            <div className="item-header">
              <div className="header-text">{t('soc.home.core')}</div>
            </div>
            <div className="item-content">
              <div className="item-text">{t('soc.home.core1')}</div>
              <div className="item-text">{t('soc.home.core2')}</div>
              <div className="item-text">{t('soc.home.core3')}</div>
              <div className="item-text">{t('soc.home.core4')}</div>
              <div className="item-add-on">
                <div className="add-on-line"></div>
                <div className="add-on-text">{t('soc.home.addOn')}</div>
                <div className="add-on-line"></div>
              </div>
              <div className="item-text">{t('soc.home.coreAddon1')}</div>
              <div className="item-text">{t('soc.home.coreAddon2')}</div>
            </div>
          </div>
          <div className="manage-item">
            <div className="item-icon">
              <img src={licenseIcon5} />
            </div>
            <div className="item-header">
              <div className="header-text">{t('soc.home.advanced')}</div>
            </div>
            <div className="item-content">
              <div className="item-text">{t('soc.home.advanced1')}</div>
              <div className="item-text">{t('soc.home.advanced2')}</div>
              <div className="item-text">{t('soc.home.advanced3')}</div>
              <div className="item-text">{t('soc.home.advanced4')}</div>
              <div className="item-add-on">
                <div className="add-on-line"></div>
                <div className="add-on-text">{t('soc.home.addOn')}</div>
                <div className="add-on-line"></div>
              </div>
              <div className="item-text">{t('soc.home.advancedAddon1')}</div>
              <div className="item-text">{t('soc.home.advancedAddon2')}</div>
            </div>
          </div>
        </div>
      </div>
      <Stack className="land-footer" justifyContent="flex-end" spacing={40}>
        <Stack>
          <span>
            {`Copyright © ${currentYear} Fortinet, Inc. All rights reserved.`}
          </span>
        </Stack>
        <Stack spacing={10} alignItems="center" style={{ fontWeight: '700' }}>
          <a href={serviceTermPdf} target="_blank">
            {t('common.footer.termsOfService')}
          </a>
          <span>|</span>
          <a href={systemData?.privacy_url} target="_blank">
            {t('common.footer.privacyPolicy')}
          </a>
          <span>|</span>
          <a href={systemData?.release_note_url} target="_blank">
            {t('common.footer.releaseNotes')}
          </a>
        </Stack>
      </Stack>
    </div>
  );
};
